<div class="exercise-container">
  <div class="exercise-nav-bar box">
    <div class="exercise-nav-bar-title">فعالیت</div>
    <div class="exercise-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="exercise-holder box">
    <p class="page-title">فعالیت‌های ثبت شده</p>
    <div>
      <div
        class="exercise-item"
        (click)="openExercise(exercise)"
        *ngFor="let exercise of exercises"
      >
        <p class="exercise-item-title">{{ exercise.name }}</p>
        <p class="exercise-item-calorie">
          {{ exercise.calorie.toFixed(0) }} کالری
        </p>
        <img src="assets/general/left-gray.svg" alt="" />
      </div>

      <div class="blue-add-button" (click)="NewExercise()">
        <div class="add-button">
          <img src="assets/plan/plus.svg" alt="" />
        </div>
        <p class="title">افزودن فعالیت</p>
      </div>
    </div>
  </div>
  <app-bottomsheet *ngIf="editExercise" [type]="type"></app-bottomsheet>
</div>
